import { render, staticRenderFns } from "./SearchSettings.vue?vue&type=template&id=443deb12&scoped=true&lang=html"
import script from "./SearchSettings.vue?vue&type=script&lang=js"
export * from "./SearchSettings.vue?vue&type=script&lang=js"
import style0 from "./SearchSettings.vue?vue&type=style&index=0&id=443deb12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443deb12",
  null
  
)

export default component.exports